import {
    booleanAttribute,
    Component,
    Input,
    OnInit,
    ViewEncapsulation
} from '@angular/core';
import { LinkComponent } from '../../../../link/link.component';
import { UMBRACO_CONSTANTS } from '../../../constants/umbraco.constants';

@Component({
    selector: 'nw-form',
    templateUrl: './form.component.html',
    styleUrls: ['./form.component.scss'],
    encapsulation: ViewEncapsulation.None,
    imports: [LinkComponent]
})
export class FormComponent implements OnInit {
    @Input() pageid!: string;
    @Input() formheading!: string;
    @Input({ transform: booleanAttribute }) showtermsandprivacypolicy: boolean = true;
    @Input({ transform: booleanAttribute }) showlogin: boolean = true;
    @Input() privacyPolicyUrl: string = UMBRACO_CONSTANTS.PRIVACY_POLICY_URL;
    @Input() termsUrl: string = UMBRACO_CONSTANTS.TERMS_URL;

    ngOnInit(): void {
        (window as any).loc =
            'https://analytics-eu.clickdimensions.com/netwealthcom-arwnx/pages/';
        (window as any).cdSurveyCdn =
            'https://cdn-eu.clickdimensions.com/web/newformeditor/';

        const scriptSrc =
            'https://cdn-eu.clickdimensions.com/web/newformeditor/CDWidget.js';

        if (!document.querySelector(`script[src="${scriptSrc}"]`)) {
            const script = document.createElement('script');
            script.src = scriptSrc;
            script.async = true;

            document.body.appendChild(script);
            return;
        }
    }
}
